import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { StepButton } from 'components/shared/StepButton/StepButton'
import { StepProgressGroup } from 'components/shared/StepProgressGroup/StepProgressGroup'
import { CategoryDetails } from '../../pages/CategoryDetails/CategoryDetails'
import { Introduction } from '../../pages/Introduction/Introduction'
import { Report } from '../../pages/Report/Report'
import { Summary } from '../../pages/Summary/Summary'

import {
  InterviewHandlersContext,
  InterviewStateContext,
} from 'components/modules/interview/context'
import { INTERVIEW_STEPS } from 'ducks/router'
import { useContext } from 'hooks'

import { ChevronLeftIcon, ChevronRightIcon } from 'components/shared/Icon/model'

import styles from './Main.module.scss'

const getSteps = () => ({
  [INTERVIEW_STEPS.INTRODUCTION]: <Introduction />,
  [INTERVIEW_STEPS.REPORT]: <Report />,
  [INTERVIEW_STEPS.SUMMARY]: <Summary />,
})

export const Main = () => {
  const state = useContext(InterviewStateContext)!
  const handlers = useContext(InterviewHandlersContext)!

  const {
    activeStep,
    steps,
    isCategoryStep,
    isPreviousStepDisabled,
    isNextStepDisabled,
    isIntroductionStep,
    isReportStep,
    isSummaryStep,
  } = state
  const { handleChangeNextStep, handleChangePreviousStep, handleChangeStep } =
    handlers

  const staticSteps = getSteps()

  return (
    <Box
      align="center"
      className={cx(styles.main, { [styles.reportWidth]: isReportStep })}
      direction="column"
      tagName="main"
    >
      {isCategoryStep || isSummaryStep ? (
        <StepProgressGroup
          className={styles.steps}
          size="large"
          steps={steps}
          onStep={handleChangeStep}
          activeStep={activeStep ?? undefined}
        />
      ) : null}
      <Box
        align="center"
        className={cx(styles.container, {
          [styles.fullHeight]: isIntroductionStep || isReportStep,
        })}
        justify="center"
      >
        {isCategoryStep || isSummaryStep ? (
          <StepButton
            ariaLabel="previous"
            icon={ChevronLeftIcon}
            onClick={handleChangePreviousStep}
            isDisabled={isPreviousStepDisabled}
          />
        ) : null}
        {staticSteps[activeStep ?? ''] ?? <CategoryDetails key={activeStep} />}
        {isCategoryStep || isSummaryStep ? (
          <StepButton
            ariaLabel="next"
            icon={ChevronRightIcon}
            onClick={handleChangeNextStep}
            isDisabled={isNextStepDisabled}
          />
        ) : null}
      </Box>
    </Box>
  )
}
